<template>
  <div class="content" style="margin-top: -35px">
    <div class="table-wrap">
      <table>
        <colgroup>
          <col style="width: 850px" />
          <col style="width: auto" />
        </colgroup>
        <tr>
          <td>
            <p class="lead">ログイン履歴を表示します。</p>
            <p class="sup-explanation">履歴の保持期間は１年です。</p>
          </td>
          <td>
            <button
              class="frm-btn ico ico-export"
              type="button"
              style="width: 150px"
              @click="handleExport"
              ref="exportButton"
            >
              エクスポート
            </button>
            <span style="margin-left: 10px; font-size: 25px">|</span>
            <button
              class="frm-btn ico ico-delete"
              type="button"
              @click="handleDelete"
            >
              ログイン履歴を削除
            </button>
          </td>
        </tr>
      </table>
    </div>
    <!-- ******************************************************************
                 *  フィルタ条件                                                  *
                 ****************************************************************** -->
    <div class="criteria">
      <!-- ******************************************************************
                   *  一覧検索                                                      *
                   ****************************************************************** -->
      <div class="frm-row">
        <div class="frm-item grow left">
          <div
            class="frm-search frm-size-xl"
            :class="searchKey ? 'setvalue' : ''"
          >
            <span class="frm-label" style="margin-left: 0.5em">
              <img src="@/assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              class="frm-search-text"
              v-model.trim="searchKey"
              placeholder="検索キーワード"
              maxlength="255"
              ref="searchIndex"
            />
          </div>
          <span class="frm-label">操作日時</span>
          <select
            class="frm-select frm-size-s"
            :class="displayTarget ? 'setvalue' : ''"
            :disabled="displayTarget == '99'"
            v-model="displayTarget"
          >
            <option
              v-for="(month, index) in dateTimeList"
              :key="index"
              :value="month.code"
              :class="displayTarget == month.code ? 'setvalue' : 'not-setvalue'"
            >
              {{ month.name }}
            </option>
            <option value="99" hidden disabled>詳細指定中</option>
          </select>
          <span class="frm-label">アカウント種別</span>
          <select class="frm-select frm-size-m setvalue" v-model="accountType">
            <option
              value="0"
              :class="accountType == '0' ? 'setvalue' : 'not-setvalue'"
            >
              税理士事務所
            </option>
            <option
              value="2"
              :class="accountType == '2' ? 'setvalue' : 'not-setvalue'"
            >
              事業者
            </option>
          </select>
          <!--絞込条件ボタン-->
          <button
            class="frm-btn ico ico-filtering"
            :class="[motoPageHandleShowBtn ? showUsed : showUnused]"
            @click="handleShowFilter"
          ></button>
          <!--すべてクリアボタン-->
          <div class="frm-item" style="margin-left: 10px">
            <button
              class="frm-btn-control ico ico-filter-close"
              :disabled="isResetDisabled"
              @click="handleReset"
            ></button>
          </div>
          <!-- <button class="frm-btn" disabled>×</button> -->
        </div>
      </div>
    </div>
    <!-- ******************************************************************
                 *  ログイン履歴一覧                                              *
                 ****************************************************************** -->
    <div class="table-wrap" style="margin-top: 0px">
      <div class="frm-row">
        <div class="frm-item grow right">
          <p>{{ countStr }}</p>
        </div>
      </div>
      <div class="table-scroll-header">
        <table class="table-select single-select">
          <colgroup>
            <!-- チェックボックス -->
            <col style="width: 40px" />
            <!-- 日時 -->
            <col style="width: 200px" />
            <!-- 処理区分 -->
            <col style="width: 150px" />
            <!-- 事業者情報 -->
            <col v-show="isShowBopUserInfo" style="width: 200px" />
            <!-- ログインID -->
            <col style="width: 200px" />
            <!-- 利用者名 -->
            <col style="width: auto" />
            <!-- IPアドレス -->
            <col style="width: 150px" />
          </colgroup>
          <thead>
            <tr>
              <th class="multi-select-item aligncenter">
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    :disabled="filteredTableList.length === 0"
                    @change="selectAllRow"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="selectAllRow"
                  ></span>
                </label>
              </th>
              <th @click="sortData('operationDateTime')">
                日時
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="
                      sort.key == 'operationDateTime' && sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'operationDateTime' && !sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th @click="sortData('operation')">
                処理区分
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'operation' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'operation' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th
                v-show="isShowBopUserInfo"
                class="alignleft"
                @click="sortData('bopUserInfo')"
              >
                事業者情報
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'bopUserInfo' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="
                      sort.key == 'bopUserInfo' && !sort.isAsc ? 'on' : ''
                    "
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft" @click="sortData('userId')">
                ログインID
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'userId' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'userId' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th class="alignleft" @click="sortData('userName')">
                利用者名
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'userName' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'userName' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
              <th @click="sortData('ipAddress')">
                IPアドレス
                <div class="sort-toggle">
                  <button
                    class="sort-toggle-asc"
                    :class="sort.key == 'ipAddress' && sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    asc
                  </button>
                  <button
                    class="sort-toggle-desc"
                    :class="sort.key == 'ipAddress' && !sort.isAsc ? 'on' : ''"
                    type="button"
                  >
                    desc
                  </button>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-scroll-body h-500px">
        <table class="table-select multi-select">
          <colgroup>
            <!-- チェックボックス -->
            <col style="width: 40px" />
            <!-- 日時 -->
            <col style="width: 200px" />
            <!-- 処理区分 -->
            <col style="width: 150px" />
            <!-- 事業者情報 -->
            <col v-show="isShowBopUserInfo" style="width: 200px" />
            <!-- ログインID -->
            <col style="width: 200px" />
            <!-- 利用者名 -->
            <col style="width: auto" />
            <!-- IPアドレス -->
            <col style="width: 150px" />
          </colgroup>
          <tbody>
            <tr
              v-for="info in filteredTableList"
              :key="info.historyId"
              :class="[info.selected ? 'selected' : '']"
              @click="selectRow(info.historyId)"
            >
              <td class="multi-select-item aligncenter">
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    :value="info.historyId"
                    :checked="info.selected"
                    @change="selectRow(info.historyId)"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="selectRow(info.historyId)"
                  ></span>
                </label>
              </td>
              <td class="aligncenter">
                <span>{{
                  $filters.formatDateTime(info.operationDateTime)
                }}</span>
              </td>
              <td class="aligncenter">
                <span>{{ typeFormat(info.operation) }}</span>
              </td>
              <td v-show="isShowBopUserInfo">
                <span>{{ info.bopUserInfo }}</span>
              </td>
              <td>
                <span>{{ info.userId }}</span>
              </td>
              <td>
                <span>{{ info.userName }}</span>
              </td>
              <td class="aligncenter">
                <span>{{ info.ipAddress }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table-select single-select"
          v-show="
            !store.getters.isProcessShow && filteredTableList.length === 0
          "
        >
          <tbody>
            <tr>
              <br />
              {{
                noDataMsg
              }}
              <br />
              <br />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：                                                                                                              _/
         _/      処理中画面(STDSDC01C03ProcessingModal)                                                                           _/
         _/      処理完了画面(STDSDC01C04ProcessingCompleteModal)                                                                         _/
         _/      ファイルエクスポート画面(STDSDC01C06FileExportModal)                                                             _/
         _/      事業者情報削除画面(STDSDC01C07ProcessingConfirmModal)                                                           _/
         _/                                                                                                                    _/
  _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <STDSDC01C03ProcessingModal></STDSDC01C03ProcessingModal>
  <STDSDC01C04ProcessingCompleteModal></STDSDC01C04ProcessingCompleteModal>
  <STDSDC01C06FileExportModal
    :pageId="pageId"
    :dateFrom="dateFrom"
    :dateTo="dateTo"
  ></STDSDC01C06FileExportModal>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：処理確認画面(STDSDC01C07ProcessingConfirmModal)  収集書類情報複写確認                                                   _/
  _/                                                                                                                    _/
  _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
  <STDSDC01C07ProcessingConfirmModal
    :isConfirmShow="isConfirmShow"
    :textArea="textArea"
    :deleteCheck="deleteCheck"
    @agree="agree($event)"
    @disagree="disagree"
  ></STDSDC01C07ProcessingConfirmModal>

  <confirm-dialog
    :isShow="isShow"
    :message="content"
    @confirm="confirm"
    @cancel="cancel"
  ></confirm-dialog>

  <STDSDC01C09FilterCompleteModal
    ref="STDSDC01C09Modal"
    :isShow="isFilterShow"
    :pageId="pageId"
    :loginSystem="loginSystem"
    :keyWordFilterInit="searchKey"
    :accessLogFilterInit="returnAccessLogFilter.data"
    :STDSDC05C08FilterInit="{
      displayTarget: displayTarget,
      dateTimeList: dateTimeList,
      accountType: accountType,
    }"
    @SearchBtn="SearchBtn"
    @CancelBtn="cancelBtn"
  ></STDSDC01C09FilterCompleteModal>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, nextTick } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import _lodash from "lodash";
import { OPERATION_STATUS_LOGIN } from "@/util/enum.js";
import Common from "@/util/common.js";
import {
  DETAIL_BUSINESS_CODE_LIST,
  DETAIL_DESIGNATED_DATE_LIST,
} from "@/util/data.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import STDSDC01C04ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import STDSDC01C06FileExportModal from "@/components/STDSDC01C06FileExportModal.vue";
import STDSDC01C07ProcessingConfirmModal from "@/components/STDSDC01C07ProcessingConfirmModal.vue";
import STDSDC01C09FilterCompleteModal from "@/components/STDSDC01C09FilterCompleteModal.vue";
import { API_SetFilter } from "@/api/Modules/CM04/STDSCM04C00.js";
import {
  API_Research,
  API_DisplayLoginHistory,
  API_DeleteLoginHistory,
} from "@/api/Modules/DC05/STDSDC05C08.js";

//#region 変数定義
const store = useStore();

//画面データリスト
const tableList = ref([]);
const allData = ref([]);
const sort = reactive({
  // 初期表示アイコン表示しない
  key: "", // ソートキー
  isAsc: false, // 昇順ならtrue,降順ならfalse
});
const noDataMsg = ref(Common.getMessage("MTCL1118", ["ログイン履歴"]));
//フィルタ条件
const isSearchKeyEnter = ref(false);
const isdisplayTargetChange = ref(false);
const isAccountTypeChange = ref(false);
const searchKey = ref("");
const displayTarget = ref("");
const defaultDateTime = ref("");
const accountType = ref(0);
const dateTimeList = ref([]);
const returnAccessLogFilter = reactive({ data: {} });
//エクスポートボタン
const exportButton = ref();
const searchIndex = ref();
// STDSDC01C06画面パラメータ
const dateFrom = ref("");
const dateTo = ref("");
//DC01C09画面パラメータ
const STDSDC01C09Modal = ref();
const loginSystem = ref(0);
const pageId = ref("STDSDC05C08");
const motoPageHandleShowBtn = ref(false);
const isFilterShow = ref(false);
//DC01C07画面パラメータ
const isConfirmShow = ref(false);
const textArea = ref("選択したログイン履歴を削除します。よろしいですか？");
const deleteCheck = ref("ログは完全に削除され、復旧することはできません");
const status = ref("");
//エラーメッセージ
const errors = ref([]);
//ボタン
const showUsed = ref("frm-btn-control setvalue ico ico-filter");
const showUnused = ref("frm-btn-control ico ico-filter");
//#endregion

//#region 画面初期化
// 初期フォーカス設定
const initFocus = () => {
  setTimeout(() => {
    searchIndex.value.focus();
  });
};
//画面データとフィルタ条件を取得
onMounted(() => {
  // 操作日時ドロップダウンリスト作成
  generateDateList();

  //store.commit("businessModule/exportDialogue", false);
  //store.commit("businessModule/processDialogue", true);
  // 収集書類情報一覧を取得する
  getList();
});
//#endregion

//#region 親画面エラー表示制御
watch(errors, (val) => {
  const topError = val?.length > 0 ? val : [];
  // vuex にコミット
  store.commit("securityModule/updateErrors", topError);
});
//#endregion

//#region エクスポートボタン-DC01C06画面処理
// エクスポートボタンをクリックする
const handleExport = () => {
  // ダイアログを開く
  errors.value = [];
  store.commit("businessModule/exportDialogue", true);
};
const setFromToDate = () => {
  if (displayTarget.value != "99") {
    if (displayTarget.value.includes("-")) {
      const seireki = displayTarget.value.split("-");
      dateFrom.value = seireki[0];
      dateTo.value = seireki[1];
    } else {
      dateFrom.value = moment(displayTarget.value).format("YYYY/MM/01");
      dateTo.value =
        moment(displayTarget.value).format("YYYY/MM/") +
        moment(displayTarget.value).daysInMonth();
    }
  } else if (displayTarget.value == "99") {
    const dateTimeFromYMD = moment(
      returnAccessLogFilter.data.accessDateFromYMD
    ).format("YYYY/MM/DD");
    const dateTimeFromYM = moment(
      returnAccessLogFilter.data.accessDateFromYM
    ).format("YYYY/MM");
    const dateTimeToYMD = moment(
      returnAccessLogFilter.data.accessDateToYMD
    ).format("YYYY/MM/DD");
    if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[1].code
    ) {
      dateFrom.value = dateTimeFromYMD;
      dateTo.value = dateTimeFromYMD;
    } else if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[2].code
    ) {
      dateFrom.value = moment(dateTimeFromYM).format("YYYY/MM/01");
      dateTo.value =
        moment(dateTimeFromYM).format("YYYY/MM/") +
        moment(dateTimeFromYM).daysInMonth();
    } else if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[3].code
    ) {
      dateFrom.value = dateTimeFromYMD;
      dateTo.value = dateTimeToYMD;
    }
  }
  reSearchData(dateFrom.value, dateTo.value);
};
//#endregion

//#region ログイン履歴を削除ボタン-DC01C07画面処理
// ログイン履歴削除ボタンをクリックする
const handleDelete = () => {
  errors.value = [];
  if (selectedIDList.value.length == 0) {
    errors.value.push(
      Common.createError(
        "MTCL1032",
        Common.getMessage("MTCL1032", ["ログイン履歴"])
      )
    );
    return;
  }
  // ダイアログを開く
  isConfirmShow.value = true;
  textArea.value = "選択したログイン履歴を削除します。よろしいですか？";
  deleteCheck.value = "履歴は完全に削除され、復旧することはできません";
  status.value = "Delete";
};
// 処理確認画面ダイアログでOKが選択された時の処理
const agree = (val) => {
  switch (status.value) {
    case "Delete":
      deleteData();
      break;
    default:
      break;
  }

  isConfirmShow.value = false;
};
// 処理確認画面ダイアログでキャンセルが選択された時の処理
const disagree = () => {
  isConfirmShow.value = false;
};
// 選択データを削除する
const deleteData = () => {
  const param = { logIds: selectedIDList.value };
  // 処理確認「はい」ボタン 非活性化
  //isDisabled.value = true;
  isConfirmShow.value = false;
  API_DeleteLoginHistory(param)
    .then((response) => {
      //正常の場合
      if (_lodash.eq(response.result, "0000")) {
        location.reload();
      }
      //上記以外の場合
      else {
        errors.value = [];
        if (response.errorCD) {
          errors.value.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      }
      // 処理確認「はい」ボタン 活性化
      isDisabled.value = false;
    })
    .catch((error) => {
      // 処理確認「はい」ボタン 活性化
      isDisabled.value = false;
    });
};
//#endregion

//#region 簡易フィルタ条件操作
// 操作日時ドロップダウンリスト設定
const generateDateList = () => {
  let dateTime = [];
  const vEndDate = new moment().format("YYYY/MM/DD");
  const vStartM = moment(vEndDate)
    .add("month", -1)
    .add("days", +1);
  const vStartDate = moment(vStartM).format("YYYY/MM/DD");
  dateTime.push({
    code: `${vStartDate}-${vEndDate}`,
    name: "直近1か月",
  });

  dateTime.push({
    code: moment(vEndDate).format("YYYY/MM"),
    name: "今月",
  });
  dateTime.push({
    code: moment(vStartDate).format("YYYY/MM"),
    name: "前月",
  });
  // dateFrom.value = vStartDate;
  // dateTo.value = vEndDate;
  dateTimeList.value = dateTime;
  displayTarget.value = `${vStartDate}-${vEndDate}`;
  defaultDateTime.value = `${vStartDate}-${vEndDate}`;
};
// フィルタ_DB保存
const saveFilter = () => {
  //子画面
  //store.commit("businessModule/processDialogue", true);
  // パラメータ設定
  const normalFilter = {
    displayTarget: displayTarget.value,
    userType: accountType.value,
  };

  const keyWordFilter = {
    searchKey: searchKey.value,
    pageID: pageId.value,
  };

  let params = {
    STDSDC05C08Filter: normalFilter,
    keyWordFilter: keyWordFilter,
  };

  // フィルター条件保存処理
  return API_SetFilter(params)
    .then(() => {
      //store.commit("businessModule/processDialogue", false);
    })
    .catch((error) => {
      console.log(error);
      //store.commit("businessModule/processDialogue", false);
    });
};
//検索キーワード
watch(
  () => searchKey.value,
  (newVal, oldVal) => {
    if (isSearchKeyEnter.value) {
      // フィルター条件の保存
      saveFilter();
    }
  },
  { deep: true }
);
// 操作日時
watch(
  () => displayTarget.value,
  (newVal, oldVal) => {
    if (
      oldVal !== undefined &&
      newVal != oldVal &&
      isdisplayTargetChange.value
    ) {
      saveFilter();
      setFromToDate();
    }
  },
  { deep: true }
);
// アカウント種別
watch(
  () => accountType.value,
  (newVal, oldVal) => {
    if (oldVal !== undefined && newVal != oldVal && isAccountTypeChange.value) {
      saveFilter();
    }
  },
  { deep: true }
);

//#endregion

//#region DC01C09_絞り込み条件画面ボタンエベント
const handleShowFilter = () => {
  isFilterShow.value = true;
};
const SearchBtn = (params) => {
  const param = _.cloneDeep(params);
  displayTarget.value = param.returnAccessLogFilter.returnCodeAccessDate;
  motoPageHandleShowBtn.value = param.motoPageHandleShowBtn;
  returnAccessLogFilter.data = param.returnAccessLogFilter;
  searchKey.value = param.searchKey;
  isFilterShow.value = false;
  setFromToDate();
};
const cancelBtn = () => {
  isFilterShow.value = false;
};
//#endregion

//#region すべてクリアボタン
//リセット制御
const isResetDisabled = computed(() => {
  if (
    !searchKey.value &&
    displayTarget.value == defaultDateTime.value &&
    accountType.value == 0 &&
    !motoPageHandleShowBtn.value
  ) {
    return true;
  } else {
    return false;
  }
});
// すべての条件をクリア
const handleReset = () => {
  const seireki = defaultDateTime.value.split("-");
  dateFrom.value = moment(seireki[0]).format("YYYY/MM/DD");
  dateTo.value = moment(seireki[1]).format("YYYY/MM/DD");
  //フィルタ条件
  searchKey.value = "";
  displayTarget.value = defaultDateTime.value;
  accountType.value = 0;
  motoPageHandleShowBtn.value = false;
  returnAccessLogFilter.data = {};
  //エラーメッセージ
  errors.value = [];
  //DC01C09_絞り込み画面の条件をクリア
  STDSDC01C09Modal.value.handleReset();
  // フィルター条件の保存
  saveFilter();
};
//#endregion

//#region 一覧テーブルのチェックボックス
const isAllSelected = computed(() => {
  return filteredTableList.value.every((info) => info.selected);
});
const selectedIDList = computed(() => {
  return filteredTableList.value
    .filter((info) => info.selected)
    .map((info) => {
      return info.historyId;
    });
});
//　行選択時の処理
const selectRow = (historyId) => {
  let log = tableList.value.find((info) => info.historyId === historyId);
  log.selected = !log.selected;
};
// 全行選択時の処理
const selectAllRow = () => {
  if (isAllSelected.value) {
    tableList.value.forEach((info) => (info.selected = false));
  } else {
    tableList.value.forEach((info) => (info.selected = true));
  }
};
//#endregion

//#region 一覧テーブル
// 一覧データを取得
const getList = () => {
  // tableList.value = DUMMY_STDSDC05C08_LOGINHISTORYDATALIST;
  store.commit("businessModule/processDialogue", true);
  return API_DisplayLoginHistory()
    .then((response) => {
      loginSystem.value = response.loginSystem;
      dateFrom.value = response.from;
      dateTo.value = response.to;
      if (_lodash.eq(response.result, "0000")) {
        if (
          response.accessLogFilter.result != "0001" &&
          response.accessLogFilter
        ) {
          returnAccessLogFilter.data = response.accessLogFilter;
          motoPageHandleShowBtn.value =
            response.accessLogFilter.motoPageHandleShowBtn;
        }
        // 保存されているフィルタ条件の適用
        if (
          response.stdsdC05C08Filter &&
          response.stdsdC05C08Filter.result != "0001"
        ) {
          const { userType } = response.stdsdC05C08Filter;

          accountType.value = userType;
          displayTarget.value = response.stdsdC05C08Filter.displayTarget;
        }
        if (response.keywordFilter.result != "0001" && response.keywordFilter) {
          searchKey.value = response.keywordFilter.searchKey;
        }
        //操作日時保存適用
        isdisplayTargetChange.value = true;
        //アカウント種別保存適用
        isAccountTypeChange.value = true;
        //検索キーワード保存適用
        isSearchKeyEnter.value = true;
        setFromToDate();
      }
      //上記以外の場合
      else {
        errors.value = [];
        if (response.errorCD) {
          if (response.errorCD == "MTCL1036") {
            tableList.value = [];
            allData.value = [];
          } else {
            // エラー表示
            errors.value.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
        store.commit("businessModule/processDialogue", false);
      }
    })
    .catch((error) => {
      console.log(error);
      store.commit("businessModule/processDialogue", false);
    })
    .finally(() => {
      nextTick(() => {
        initFocus();
      });
    });
};
const reSearchData = (from, to) => {
  const param = {
    from,
    to,
  };
  // 成功の場合
  store.commit("businessModule/processDialogue", true);
  API_Research(param)
    .then((response) => {
      if (_.eq(response.result, "0000")) {
        //一覧データ
        tableList.value = response.data;
        tableList.value = tableList.value.map((row) => {
          return {
            ...row,
            selected: false,
            bopUserInfo:
              (row.businessOperatorCode ? row.businessOperatorCode : "") +
              " " +
              (row.businessOperatorName ? row.businessOperatorName : ""),
          };
        });
        allData.value = [...tableList.value];
      }
      //失敗の場合
      else {
        errors.value = [];
        if (response.errorCD) {
          if (response.errorCD == "MTCL1036") {
            tableList.value = [];
            allData.value = [];
          } else {
            // エラー表示
            errors.value.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        }
      }
      store.commit("businessModule/processDialogue", false);
    })
    .catch((error) => {
      console.log(error);
      store.commit("businessModule/processDialogue", false);
    })
    .finally(() => {
      nextTick(() => {
        initFocus();
      });
    });
};
// ソート実施
const sortData = (key) => {
  Common.sortData2(sort, key);
};
// 件数
const countStr = computed(() => {
  return `${filteredTableList.value.length.toLocaleString()}/${allData.value.length.toLocaleString()}件`;
});

// 処理区分のフォーマット
const typeFormat = (data) => {
  // ログイン
  if (data == OPERATION_STATUS_LOGIN.login.code) {
    return OPERATION_STATUS_LOGIN.login.text;
    // ログアウト
  } else if (data == OPERATION_STATUS_LOGIN.loginOut.code) {
    return OPERATION_STATUS_LOGIN.loginOut.text;
  }
};

//日付のフォーマット(YYYY/MM/DD HH:mm:ss)
const formatDateTime = (value) => {
  return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
};

// フィルターしてテーブル取得
const filteredTableList = computed(() => {
  let filterInfo = allData.value;

  // アカウント種別検索
  filterInfo = filterInfo.filter((item) => {
    return item.keyNameType == accountType.value;
  });

  // 操作日時検索
  if (_lodash.includes(displayTarget.value, "-")) {
    filterInfo = filterInfo.filter((item) => {
      const seireki = displayTarget.value.split("-");
      const fromDate = moment(seireki[0]).format("YYYY/MM/DD");
      const toDate = moment(seireki[1]).format("YYYY/MM/DD");
      const time = moment(item.operationDateTime).format("YYYY/MM/DD");
      return moment(time).isBetween(fromDate, toDate, undefined, "[]");
    });
  } else if (displayTarget.value == 99) {
    const dateTimeFromYMD = moment(
      returnAccessLogFilter.data.accessDateFromYMD
    ).format("YYYY/MM/DD");
    const dateTimeFromYM = moment(
      returnAccessLogFilter.data.accessDateFromYM
    ).format("YYYY/MM");
    const dateTimeToYMD = moment(
      returnAccessLogFilter.data.accessDateToYMD
    ).format("YYYY/MM/DD");
    const fromDateYMD = new Date(dateTimeFromYMD);
    const fromDateYM = new Date(dateTimeFromYM);
    const toDateYMD = new Date(dateTimeToYMD);
    if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[1].code
    ) {
      filterInfo = filterInfo.filter((item) => {
        const d = moment(item.operationDateTime).format("YYYY/MM/DD");
        return d == dateTimeFromYMD;
      });
    } else if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[2].code
    ) {
      filterInfo = filterInfo.filter((item) => {
        const d = moment(item.operationDateTime).format("YYYY/MM");
        return d == dateTimeFromYM;
      });
    } else if (
      returnAccessLogFilter.data.accessDateTimeFromOption ==
      DETAIL_DESIGNATED_DATE_LIST[3].code
    ) {
      filterInfo = filterInfo.filter((item) => {
        const time = moment(item.operationDateTime).format("YYYY/MM/DD");
        return moment(time).isBetween(
          dateTimeFromYMD,
          dateTimeToYMD,
          undefined,
          "[]"
        );
      });
    }
  } else {
    filterInfo = filterInfo.filter((item) => {
      const toDate = new Date(moment(displayTarget.value).format("YYYY/MM"));
      const d = new Date(moment(item.operationDateTime).format("YYYY/MM"));
      return d.getTime() == toDate.getTime();
    });
  }

  // キーワード検索
  if (searchKey.value) {
    //検索キーワード
    filterInfo = filterInfo.filter((item) => {
      return (
        formatDateTime(item.operationDateTime).includes(searchKey.value) ||
        typeFormat(item.operation).includes(searchKey.value) ||
        item.bopUserInfo.includes(searchKey.value) ||
        item.userId.includes(searchKey.value) ||
        item.userName.includes(searchKey.value) ||
        item.ipAddress.includes(searchKey.value)
      );
    });
  }

  //処理区分
  if (returnAccessLogFilter.data.processingDivisionList?.length > 0) {
    filterInfo = filterInfo.filter((element) => {
      return returnAccessLogFilter.data.processingDivisionList.some(
        (e) => e == element.operation
      );
    });
  }

  //事業者情報
  if (returnAccessLogFilter.data.bopUser) {
    // 「右記を含む」の場合
    if (
      returnAccessLogFilter.data.bopUserOption ==
      DETAIL_BUSINESS_CODE_LIST[1].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return _lodash.includes(
          element.bopUserInfo.toString(),
          returnAccessLogFilter.data.bopUser
        );
      });
      // 「右記を含まない」の場合
    } else if (
      returnAccessLogFilter.data.bopUserOption ==
      DETAIL_BUSINESS_CODE_LIST[2].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return !_lodash.includes(
          element.bopUserInfo.toString(),
          returnAccessLogFilter.data.bopUser
        );
      });
    }
  }

  //ログインID
  if (returnAccessLogFilter.data.userID) {
    // 「右記を含む」の場合
    if (
      returnAccessLogFilter.data.userIDOption ==
      DETAIL_BUSINESS_CODE_LIST[1].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return _lodash.includes(
          element.userId.toString(),
          returnAccessLogFilter.data.userID
        );
      });
      // 「右記を含まない」の場合
    } else if (
      returnAccessLogFilter.data.userIDOption ==
      DETAIL_BUSINESS_CODE_LIST[2].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return !_lodash.includes(
          element.userId.toString(),
          returnAccessLogFilter.data.userID
        );
      });
    }
  }

  //利用者名
  if (returnAccessLogFilter.data.userName) {
    // 「右記を含む」の場合
    if (
      returnAccessLogFilter.data.userNameOption ==
      DETAIL_BUSINESS_CODE_LIST[1].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return _lodash.includes(
          element.userName.toString(),
          returnAccessLogFilter.data.userName
        );
      });
      // 「右記を含まない」の場合
    } else if (
      returnAccessLogFilter.data.userNameOption ==
      DETAIL_BUSINESS_CODE_LIST[2].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return !_lodash.includes(
          element.userName.toString(),
          returnAccessLogFilter.data.userName
        );
      });
    }
  }

  //IPアドレス
  if (returnAccessLogFilter.data.ipAddress) {
    // 「右記を含む」の場合
    if (
      returnAccessLogFilter.data.ipAddressOption ==
      DETAIL_BUSINESS_CODE_LIST[1].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return _lodash.includes(
          element.ipAddress.toString(),
          returnAccessLogFilter.data.ipAddress
        );
      });
      // 「右記を含まない」の場合
    } else if (
      returnAccessLogFilter.data.ipAddressOption ==
      DETAIL_BUSINESS_CODE_LIST[2].code
    ) {
      filterInfo = filterInfo.filter((element) => {
        return !_lodash.includes(
          element.ipAddress.toString(),
          returnAccessLogFilter.data.ipAddress
        );
      });
    }
  }

  //ソート実行
  return Common.listSort2(sort.key, sort.isAsc, filterInfo);
});
//#endregion

//#region 一覧テーブルのカラム表示制御
const isShowBopUserInfo = computed(() => {
  return accountType.value == "2";
});
//#endregion
</script>

